export default __webpack_public_path__ + "static/media/Epic.31b3db5d.svg";